import React, { Component } from "react";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import Loading from "./Loading";

// Returns school list based on selected university (population ID)
const getSchoolsForUniversity = (universityId) => {
  const uid = parseInt(universityId);
  if (uid === 3) {
    // Nova University Lisbon
    return [
      { Id: "School of Engineering", value: "School of Engineering" },
    ];
  }
  // Coventry (and any other university): all 6 schools
  return [
    { Id: "School of Business", value: "School of Business" },
    { Id: "School of Computing", value: "School of Computing" },
    { Id: "School of Engineering", value: "School of Engineering" },
    { Id: "School of Design & Media", value: "School of Design & Media" },
    { Id: "School of Psychology", value: "School of Psychology" },
    { Id: "School of Physiotherapy", value: "School of Physiotherapy" },
  ];
};

// Explicit program-to-school mapping per university
// Each entry lists the exact program names that belong to each school
// These are matched against the curriculum description strings from the API
const universityProgramMapping = {
  // Coventry University (population ID 2 or default)
  coventry: {
    "School of Business": [
      "Business Administration",       // BBA
      "Business and Marketing",        // BM
      "Digital Marketing",             // ADM (Advertising and Digital Marketing)
      "Finance and Investment",        // FI
      "Accounting and Finance",        // ACF
    ],
    "School of Computing": [
      "Computer Science",              // CS
      "Software Engineering",          // SWE
      "Ethical Hacking",               // EHC
      "Cybersecurity",                 // EHC (alt match)
    ],
    "School of Engineering": [
      "Civil Engineering",             // CENG
      "Mechanical Engineering",        // MENG
      "Electrical",                    // EEE (Electrical and Electronic Engineering)
    ],
    "School of Design & Media": [
      "Product Design",                // PD
      "Fashion Business",              // IFB (International Fashion Business)
      "Film Production",               // FP
      "Interior Architecture",         // IAD (Interior Architecture and Design)
      "Digital Media",                 // DM
      "Graphic Design",                // GD
    ],
    "School of Psychology": [
      "Psychology",                     // PSYC
    ],
    "School of Physiotherapy": [
      "Physiotherapy",                  // PHYSIO
    ],
  },
  // Nova University (population ID 3)
  nova: {
    "School of Business": [
      "Information Management",        // INFM
    ],
    "School of Engineering": [
      "Industrial Engineering",        // IEMG (Industrial Engineering and Management)
      "Environmental Engineering",     // ENVE
    ],
  },
};

// Helper: get the program mapping for a given university ID
const getProgramMapping = (universityId) => {
  const uid = parseInt(universityId);
  if (uid === 3) return universityProgramMapping.nova;
  return universityProgramMapping.coventry;
};

// Helper: filter majors list by selected school for a given university
const filterBySchool = (majors, selectedSchool, universityId) => {
  if (!selectedSchool || selectedSchool === 0 || selectedSchool === "0") return majors;
  const mapping = getProgramMapping(universityId);
  const programs = mapping[selectedSchool] || [];
  if (programs.length === 0) return majors;
  return majors.filter(m =>
    programs.some(p => m.value.toLowerCase().includes(p.toLowerCase()))
  );
};

export default class AcademicInterest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entryTermData: [],
      selectedEntryTerm: 0,
      programsData: [],
      selectedProgram: 0,
      majorsData: [],
      selectedSchool: 0,
      selectedSecondSchool: 0,

      selectedMajor: 1,
      selectedUniversity: 0,
      universityData: [],
      universityData2: [],
      selectedSecondUniversity: 0,
      universitySecondData: [],
      selectedSecondProgram: 0,
      programsSecondData: [],
      selectedSecondMajor: 0,
      majorSecondData: [],
      loading: true,
      description: "",
      secondDescription: "",
      selectedLevel: 0,
      levelData: [],
      levelFoundationData: [],
      selectedSecondLevel: 0,
      levelSecondData: [],
      isFoundation: false,
      foundationId: 0,
      preferredCampus: "",
      isPopup: false,
      isWestEnabled: false,
      isclear: false,
    };

    this.handleProgramSelect = this.handleProgramSelect.bind(this);
    this.handleSecondProgramSelect = this.handleSecondProgramSelect.bind(this);
    this.fetchLevel = this.fetchLevel.bind(this);
    this.fetchSecondLevel = this.fetchSecondLevel.bind(this);
    this.changeForFoundation = this.changeForFoundation.bind(this);
    this.changeForFoundationSecondLevel =
      this.changeForFoundationSecondLevel.bind(this);
  }
  static getDerivedStateFromProps(props, state) {
    const {
      majorsData,
      selectedProgram,
      selectedMajor,
      selectedEntryTerm,
      loading,
      error,
      entryTermData,
      description,
      selectedUniversity,
      universityData,
      selectedSecondUniversity,
      universitySecondData,
      selectedSecondProgram,
      selectedSecondMajor,
      majorSecondData,
      secondDescription,
      selectedLevel,
      levelData,
      selectedSecondLevel,
      levelSecondData,
      isFoundation,
      foundationId,
      levelFoundationData,
      preferredCampus,
      isPopup,
    } = state;
    let foundationRow = [];
    if (
      props.isFoundation !== state.isFoundation &&
      props.isFoundation == true
    ) {
      const foundationRow = state.levelData.find((obj) => {
        return obj.value === "FOUNDATION";
      });
      let foundationId = 0;
      let foundationRows = [];
      if (
        ["", null, undefined, 0, []].indexOf(parseInt(foundationRow)) &&
        foundationRow !== undefined
      ) {
        foundationId = foundationRow.Id;
        foundationRows = [foundationRow];
      } else {
        foundationId = 0;
        foundationRows = [];
      }
      if (
        props.isFoundation &&
        props.selectedSecondMajor !== "" &&
        props.selectedSecondMajor !== null &&
        props.selectedSecondMajor !== undefined
      ) {
        props.collectState("AI", {
          selectedEntryTerm: selectedEntryTerm,
          selectedProgram: selectedProgram,
          selectedMajor: selectedMajor,
          description: description,
          selectedUniversity: selectedUniversity,
          selectedSecondUniversity: selectedSecondUniversity,
          selectedSecondProgram: selectedSecondProgram,
          selectedSecondMajor: selectedSecondMajor,
          secondDescription: secondDescription,
          selectedLevel: "",
          selectedSecondLevel: selectedSecondLevel,
          preferredCampus: preferredCampus,
        });
        return {
          isFoundation: props.isFoundation,
          levelFoundationData: foundationRows,
          foundationId: foundationId,
          selectedLevel: "",
          selectedSecondLevel: "",
        };
      } else {
        return {
          isFoundation: props.isFoundation,
          levelFoundationData: foundationRows,
          foundationId: foundationId,
          selectedLevel: "",
          /* levelData: foundationRows*/
        };
      }
    } else if (
      props.isFoundation !== state.isFoundation &&
      props.isFoundation == false
    ) {
      return {
        isFoundation: props.isFoundation,
      };
    }

    return null;
  }

  changeForFoundation() {
    let foundationRow = [];
    if (this.props.isFoundation == true) {
      foundationRow = this.state.levelData.find((obj) => {
        return obj.value === "FOUNDATION";
      });
      let foundationId = 0;
      let foundationRows = [];

      if (
        ["", null, undefined, 0, []].indexOf(parseInt(foundationRow)) &&
        foundationRow !== undefined
      ) {
        foundationId = foundationRow.Id;
        foundationRows = [foundationRow];
      } else {
        foundationId = 0;
        foundationRows = [];
      }

      this.setState({
        isFoundation: this.props.isFoundation,
        levelFoundationData: foundationRows,
        foundationId: foundationId,
        //selectedLevel: foundationId,
        /* levelData: foundationRows*/
      });
    } else if (this.props.isFoundation == false) {
      this.setState({
        isFoundation: this.props.isFoundation,
      });
    }
  }

  changeForFoundationSecondLevel() {
    let foundationRow = [];
    if (this.props.isFoundation == true) {
      foundationRow = this.state.levelSecondData.find((obj) => {
        return obj.value === "FOUNDATION";
      });
      let foundationId = 0;
      let foundationRows = [];

      if (
        ["", null, undefined, 0, []].indexOf(parseInt(foundationRow)) &&
        foundationRow !== undefined
      ) {
        foundationId = foundationRow.Id;
        foundationRows = [foundationRow];
      } else {
        foundationId = 0;
        foundationRows = [];
      }
      this.setState({
        isFoundation: this.props.isFoundation,
        levelFoundationData: foundationRows,
        foundationId: foundationId,
        //selectedSecondLevel: foundationId,
        /* levelData: foundationRows*/
      });
    } else if (this.props.isFoundation == false) {
      this.setState({
        isFoundation: this.props.isFoundation,
      });
    }
  }
  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetEntryTerm`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          entryTermData: res,
          selectedEntryTerm: res.includes(this.props.entryTerm)
            ? this.props.entryTerm
            : 0,
        });
        this.handleProgramSelect(1);
        this.handleSecondProgramSelect(1);
        this.fetchLevel(this.props.description, this.props.preferredCampus);
        this.fetchSecondLevel(
          this.props.secondDescription,
          this.props.preferredCampus
        );
      })
      .catch((err) => console.log(err))

      .catch((err) => console.log(err))
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetPopulation`
        )
      )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          universityData: res,
          universityData2: res,
          selectedUniversity: this.props.selectedUniversity || "",
        });
        this.setState({
          universitySecondData: res,
          selectedSecondUniversity: this.props.selectedSecondUniversity || "",
        });
        //this.handleProgramSelect(this.props.selectedProgram,this.props.selectedUniversity)
        //this.handleSecondProgramSelect(this.props.selectedSecondProgram,this.props.selectedSecondUniversity)
        this.setState({ preferredCampus: this.props.preferredCampus });
        if (
          ["", null, undefined, 0].indexOf(
            parseInt(this.props.selectedProgram)
          ) === -1 &&
          ["", null, undefined, 0].indexOf(
            parseInt(this.props.selectedUniversity)
          ) === -1
        ) {
          fetch(
            `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?programId=` +
            (this.props.selectedProgram || 0) +
            `&populationId=` +
            (this.props.selectedUniversity || 0) +
            `&campus=` +
            (this.props.preferredCampus || "East")
          )
            .then((res) => res.json())
            .then((res) => {
              this.setState({ majorsData: res });
              if (res.length) {
                if (
                  parseInt(this.props.selectedProgram) ===
                  parseInt(this.props.selectedProgram)
                ) {
                  let setVal = "";
                  res.forEach((element) => {
                    if (element.value === this.props.description) {
                      const { selectedEntryTerm } = this.state;
                      this.setState({
                        selectedMajor: element.Id,
                        description: this.props.description,
                        selectedLevel: this.props.selectedLevel,
                      });
                      this.props.collectState("AI", {
                        selectedEntryTerm: selectedEntryTerm,
                        selectedProgram: this.props.selectedProgram,
                        selectedMajor: element.Id,
                        description: this.props.description,
                        selectedUniversity: this.props.selectedUniversity,
                        selectedSecondUniversity:
                          this.props.selectedSecondUniversity,
                        selectedSecondProgram: this.props.selectedSecondProgram,
                        selectedSecondMajor: this.props.selectedSecondMajor,
                        secondDescription: this.props.secondDescription,
                        selectedLevel: this.props.selectedLevel,
                        selectedSecondLevel: this.props.selectedSecondLevel,
                        isFoundation: this.props.isFoundation,
                        preferredCampus: this.props.preferredCampus,
                      });
                    }
                  });
                }
              }
            });
        }
        if (
          ["", null, undefined, 0].indexOf(
            parseInt(this.props.selectedSecondProgram)
          ) === -1 &&
          ["", null, undefined, 0].indexOf(
            parseInt(this.props.selectedSecondUniversity)
          ) === -1
        ) {
          fetch(
            `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?programId=` +
            (this.props.selectedSecondProgram || 0) +
            `&populationId=` +
            (this.props.selectedSecondUniversity || 0) +
            `&campus=` +
            (this.props.preferredCampus || "East")
          )
            .then((res) => res.json())
            .then((res) => {
              this.setState({ majorSecondData: res });
              if (res.length) {
                if (
                  parseInt(this.props.selectedSecondProgram) ===
                  parseInt(this.props.selectedSecondProgram)
                ) {
                  let setVal = "";
                  res.forEach((element) => {
                    if (element.value === this.props.secondDescription) {
                      this.setState({
                        selectedSecondMajor: element.Id,
                        secondDescription: this.props.secondDescription,
                        selectedSecondLevel: this.props.selectedSecondLevel,
                      });
                    }
                  });
                }
              }
            });
        }
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/AcademicInterest/CheckWestCampus`
        )
          .then((res) => res.json())
          .then((res) => {
            if (this.props.preferredCampus === "West" && res === false) {
              this.props.changePopup("WestRemoved");
              this.setState({ isWestEnabled: res, preferredCampus: "" });
            }
            this.setState({ isWestEnabled: res });
          })
      )
      .catch((err) => console.log(err));
  }

  fetchLevel(val, camp) {
    var level = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLevels?programOfStudy=${val}&campus=${camp}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ levelData: res });
        if (res.length) {
          //this.setState({ selectedLevel: this.props.selectedLevel})
          return "";
        }
      })
      .then((res) => {
        this.changeForFoundation();
      })
      .catch((err) => console.log(err));
    return level;
  }

  fetchSecondLevel(val, camp) {
    var secondLevel = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLevels?programOfStudy=${val}&campus=${camp}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ levelSecondData: res });
        if (res.length) {
          //this.setState({ selectedSecondLevel: this.props.selectedSecondLevel})
          return "";
        }
      })
      .then((res) => {
        this.changeForFoundationSecondLevel();
      })
      .catch((err) => console.log(err));
    return secondLevel;
  }

  handleCampusSelect(camp) {
    const { universityData2, selectedUniversity } = this.state;

    //console.log(universityData2)
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/getActiveUniversities?campus=${camp}`
    )
      .then((res) => res.json())
      .then((res) => {
        let uni = universityData2.slice();
        if (res.length) {
          res.forEach((element) => {
            uni.forEach((element2) => {
              if (element == element2.Id) {
                uni.splice(
                  uni.findIndex(function (i) {
                    return i.Id === element;
                  }),
                  1
                );

                this.handleProgramSelect(1, 0, camp);
              }
            });
          });
        }
        this.setState({ universityData: uni, selectedUniversity: 0 });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedProgram: this.state.selectedProgram,
          selectedMajor: this.state.selectedMajor,
          //description: description,
          description: this.state.description, //descriptions && descriptions.length > 0 ? descriptions[0].value : '',
          secondDescription: this.state.secondDescription,
          selectedUniversity: 0,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedLevel: this.state.selectedLevel,
          selectedSecondProgram: this.state.selectedSecondProgram,
          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondLevel: this.state.selectedSecondLevel,
          preferredCampus: this.state.preferredCampus,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleProgramSelect(e, val, camp) {
    const { selectedEntryTerm } = this.state;
    this.setState({ selectedProgram: e });
    // fetch data of majors and set its state here
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?programId=${e}&populationId=${val || 0}&campus=${camp || "East"}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        if (res.length) {
          if (parseInt(e) === parseInt(this.props.selectedProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.description) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedMajor: setVal,
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: e,
              selectedMajor: setVal,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              preferredCampus: this.props.preferredCampus,
            });
          } else {
            this.setState({
              selectedMajor: "",
              description: "",
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: e,
              selectedMajor: "",
              description: "",
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              preferredCampus: this.props.preferredCampus,
            });
          }
        } else {
          this.setState({
            selectedMajor: "",
            description: "",
            loading: false,
            selectedLevel: this.props.selectedLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: selectedEntryTerm,
            selectedProgram: e,
            selectedMajor: "",
            description: "",
            selectedUniversity: this.props.selectedUniversity,
            selectedSecondUniversity: this.props.selectedSecondUniversity,
            selectedSecondProgram: this.props.selectedSecondProgram,
            selectedSecondMajor: this.props.selectedSecondMajor,
            secondDescription: this.props.secondDescription,
            selectedLevel: this.props.selectedLevel,
            selectedSecondLevel: this.props.selectedSecondLevel,
            preferredCampus: this.props.preferredCampus,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleSecondProgramSelect(e, val, camp) {
    const { selectedEntryTerm } = this.state;
    this.setState({ selectedSecondProgram: e });

    // fetch data of majors and set its state here
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?programId=${e}&populationId=${val || 0}&campus=${camp || "East"}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorSecondData: res });
        if (res.length) {
          if (parseInt(e) === parseInt(this.props.selectedSecondProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.secondDescription) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedSecondMajor: setVal,
              secondDescription: this.props.secondDescription,
              loading: false,
              selectedSecondLevel: this.props.selectedSecondLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: this.props.selectedProgram,
              selectedMajor: this.state.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: e,
              selectedSecondMajor: setVal,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              preferredCampus: this.props.preferredCampus,
            });
          } else {
            this.setState({
              selectedSecondMajor: "",
              secondDescription: "",
              loading: false,
              selectedSecondLevel: this.props.selectedSecondLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: e,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: "",
              secondDescription: "",
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              preferredCampus: this.props.preferredCampus,
            });
          }
        } else {
          this.setState({
            selectedSecondMajor: "",
            secondDescription: "",
            loading: false,
            selectedSecondLevel: this.props.selectedSecondLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: selectedEntryTerm,
            selectedProgram: e,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            selectedUniversity: this.props.selectedUniversity,
            selectedSecondUniversity: this.props.selectedSecondUniversity,
            selectedSecondProgram: this.props.selectedSecondProgram,
            selectedSecondMajor: "",
            secondDescription: "",
            selectedLevel: this.props.selectedLevel,
            selectedSecondLevel: this.props.selectedSecondLevel,
            preferredCampus: this.props.preferredCampus,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (this.state.isclear == false) {
      const preferredCampus = this.state.preferredCampus || "East";

      console.log(preferredCampus);
      if (preferredCampus != null && preferredCampus != "") {
        this.handleCampusSelect(preferredCampus.toString());
        this.setState({ isclear: true, preferredCampus: preferredCampus });
      }
    }

    const validationError = this.props.error;

    const {
      majorsData,
      selectedProgram,
      selectedSchool,
      selectedSecondSchool,
      selectedMajor,
      selectedEntryTerm,
      loading,
      error,
      entryTermData,
      description,
      selectedUniversity,
      universityData,
      selectedSecondUniversity,
      universitySecondData,
      selectedSecondProgram,
      selectedSecondMajor,
      majorSecondData,
      secondDescription,
      selectedLevel,
      levelData,
      selectedSecondLevel,
      levelSecondData,
      isFoundation,
      foundationId,
      levelFoundationData,
      preferredCampus,
      isPopup,
      isWestEnabled,
    } = this.state;

    if (loading) {
      return <Loading />;
    }
    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <br />
          <span>
            <b>First Choice</b>
          </span>{" "}
          <br />
          <div>
            <InputRow
              name="select"
              rowName="University"
              required="*"
              value={selectedUniversity}
              hover="Please select the university you are applying for. يرجى تحديد الجامعة التي تتقدم بالطلب عليها"
              errMsg={
                validationError.selectedUniversity
                  ? validationError.selectedUniversity
                  : ""
              }
              data={universityData}
              onChange={(e) => {
                const descriptions2 = universityData.filter(
                  (element) => element.Id === parseInt(e)
                );
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: "",
                  description: "",
                  secondDescription: secondDescription,
                  selectedUniversity:
                    descriptions2 && descriptions2.length > 0
                      ? descriptions2[0].value
                      : "",
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedLevel: "",
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  selectedSecondLevel: selectedSecondLevel,
                  preferredCampus: preferredCampus,
                });

                // Reset school, major, level when university changes
                this.setState({ selectedUniversity: e, selectedMajor: "", description: "", selectedSchool: 0, selectedLevel: "" });
                if (descriptions2.length > 0) {
                  this.handleProgramSelect(
                    1,
                    descriptions2[0].Id,
                    preferredCampus
                  );
                }
              }}
            />

            <InputRow
              name="select"
              rowName="Entry Term"
              value={selectedEntryTerm}
              required="*"
              hover="Please select the term you are interested in. يرجى تحديد الفصل الدراسي الذي ترغب فيه."
              errMsg={
                validationError.selectedEntryTerm
                  ? validationError.selectedEntryTerm
                  : ""
              }
              data={entryTermData}
              onChange={(e) => {
                // this.handleProgramSelect(1)
                this.setState({ selectedEntryTerm: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: e,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  //seconddescription : secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: selectedSecondLevel,
                  preferredCampus: preferredCampus,
                });
              }}
            // hover="Please select the term you're interested in. Fall semester is the semester that starts in September. يرجى تحديد المدة التي تهتم بها. الفصل الدراسي الخريف هو الفصل الدراسي الذي يبدأ في سبتمبر. "
            />
            {(selectedEntryTerm === "1018" || selectedEntryTerm === 1018) &&
              (selectedUniversity === 3 || selectedUniversity === "3") ? (
              <p style={{ color: "red" }}>
                Kindly note that NOVA University Lisbon admission is ONLY
                available for the First Semester of the academic year 2025/2026,
                which commences in September 2025. If you apply to the Second
                Semester, you will be automatically considered for the First
                Semester of the academic year 2025/2026
              </p>
            ) : null}
            {(selectedEntryTerm === "1021" || selectedEntryTerm === 1021) &&
              (selectedUniversity === 3 || selectedUniversity === "3") ? (
              <p style={{ color: "red" }}>
                Please note that Semester 2 intake for 2025 at Nova University is not available.
                If you select Nova University – Semester 2 (2025), your application will be automatically deferred to the September 2026 intake.
              </p>
            ) : null}

            <InputRow
              name="select"
              rowName="School"
              value={selectedSchool}
              required="*"
              hover="Please select the school you are interested in."
              data={getSchoolsForUniversity(selectedUniversity)}
              onChange={(e) => {
                this.setState({ selectedSchool: e, selectedMajor: "", description: "", selectedLevel: "", levelData: [] });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: "",
                  description: "",
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: "",
                  selectedSecondLevel: selectedSecondLevel,
                  preferredCampus: preferredCampus,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Degree/Program"
              value={selectedMajor}
              required="*"
              hover="You can change your Programme until the Second Semester of Foundation Year . Conditional and Final Offer Letters are issued with the First Choice requested on your Online Application . "
              errMsg={
                validationError.selectedMajor
                  ? validationError.selectedMajor
                  : ""
              }
              data={filterBySchool(majorsData, selectedSchool, selectedUniversity)}
              onChange={(e) => {
                const descriptions = majorsData.filter(
                  (element) => element.Id === parseInt(e)
                );

                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: e,
                  description:
                    descriptions && descriptions.length > 0
                      ? descriptions[0].value
                      : "",
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: "",
                  selectedSecondLevel: selectedSecondLevel,
                  preferredCampus: preferredCampus,
                });
                this.setState({
                  selectedMajor: e,
                  description:
                    descriptions && descriptions.length > 0
                      ? descriptions[0].value
                      : "",
                  selectedLevel: "",
                  levelData: [],
                });
                //  this.setState({ selectedMajor: e, description: descriptions && descriptions.length > 0 ? descriptions[0].value : '' })
                if (descriptions.length > 0) {
                  this.fetchLevel(descriptions[0].value, preferredCampus);
                }
              }}
            />
            {(selectedEntryTerm === "1021" || selectedEntryTerm === 1021) &&
              (selectedUniversity === 2 || selectedUniversity === "2") &&
              (selectedMajor === "121" || selectedMajor === 121) ? (
              <p style={{ color: "red" }}>
                The Physiotherapy program is not available for Semester 2 (2025).
                Applications for this program and semester will be automatically deferred to the September 2026 intake.
              </p>
            ) : null}

            <InputRow
              name="select"
              rowName="Level"
              required="*"
              errMsg={
                validationError.selectedLevel
                  ? validationError.selectedLevel
                  : ""
              }
              value={selectedLevel}
              data={isFoundation == true ? levelFoundationData : levelData}
              //disabled={isFoundation}
              onChange={(e) => {
                this.setState({ selectedLevel: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  secondDescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  selectedLevel: e,
                  selectedSecondLevel: selectedSecondLevel,
                  preferredCampus: preferredCampus,
                });
                // this.setState({ selectedMajor: selectedMajor, description: description })
              }}
            />
          </div>
          {selectedLevel === "14" ? (
            <p style={{ color: "red" }}>
              Please note that your selection of entry into Year 3/Level 6 will
              be approved on a case-by-case basis, depending on the programme
              you are applying for. If your enrolment into Year 3/Level 6 is not
              approved by Coventry University, your application will be
              considered for enrolment into Year 2/Level 5, or Year 1/Level 4
            </p>
          ) : null}
          {selectedLevel === "11" &&
            (description.includes("/ BENG /") ||
              description.includes("Engineering")) ? (
            <p style={{ color: "red" }}>
              The Year 1 entry selection process for the School of Engineering
              is solely applicable to transfer students from accredited
              institutions of higher education. If You are applying to the
              School of Engineering based on your high-school grades, you will
              be automatically considered for Foundation Year due to equivalency
              requirements.
            </p>
          ) : null}
          <span>
            <b>Second Choice</b>
          </span>{" "}
          <br />
          <div>
            <InputRow
              name="select"
              rowName="University"
              hover="Please select the university you are applying for. يرجى تحديد الجامعة التي تتقدم بالطلب عليها"
              value={selectedSecondUniversity}
              data={universityData}
              onChange={(e) => {
                const descriptions1 = universityData.filter(
                  (element) => element.Id === parseInt(e)
                );
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  secondDescription: "",
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: e,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: "",
                  preferredCampus: preferredCampus,
                });

                // Reset second school, major, level when second university changes
                this.setState({
                  selectedSecondUniversity: e,
                  selectedSecondMajor: "",
                  secondDescription: "",
                  selectedSecondSchool: 0,
                  selectedSecondLevel: "",
                });
                if (descriptions1.length > 0) {
                  this.handleSecondProgramSelect(
                    1,
                    descriptions1[0].Id,
                    preferredCampus
                  );
                }
              }}
            />
            {(selectedEntryTerm === "1021" || selectedEntryTerm === 1021) &&
              (selectedSecondUniversity === 3 || selectedSecondUniversity === "3") ? (
              <p style={{ color: "red" }}>
                Please note that Semester 2 intake for 2025 at Nova University is not available.
                If you select Nova University – Semester 2 (2025), your application will be automatically deferred to the September 2026 intake.
              </p>
            ) : null}

            <InputRow
              name="select"
              rowName="School"
              value={selectedSecondSchool}
              hover="Please select the school you are interested in."
              data={getSchoolsForUniversity(selectedSecondUniversity)}
              onChange={(e) => {
                this.setState({ selectedSecondSchool: e, selectedSecondMajor: "", secondDescription: "", selectedSecondLevel: "", levelSecondData: [] });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: "",
                  secondDescription: "",
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: "",
                  preferredCampus: preferredCampus,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Degree/Program"
              value={selectedSecondMajor}
              hover="You can change your program until the second semester of the foundation year"
              data={filterBySchool(majorSecondData, selectedSecondSchool, selectedSecondUniversity)}
              onChange={(e) => {
                const desc = majorSecondData.filter(
                  (element) => element.Id === parseInt(e)
                );
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: e,
                  secondDescription:
                    desc && desc.length > 0 ? desc[0].value : "",
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: "",
                  preferredCampus: preferredCampus,
                });

                this.setState({
                  selectedSecondMajor: e,
                  secondDescription:
                    desc && desc.length > 0 ? desc[0].value : "",
                  selectedSecondLevel: "",
                  levelSecondData: [],
                });

                if (desc[0].Id == selectedMajor) {
                  this.setState({ selectedSecondMajor: "" });
                  alert("You cannot choose the same Program");
                  // this.setState({ pedError: 'Please enter a valid Passport expiry Date conditions.' , passportExpiryDate: ''})
                  return "";
                }

                //  this.setState({selectedSecondMajor: e, secondDescription: desc && desc.length > 0 ? desc[0].value : ''})
                if (desc.length > 0) {
                  this.fetchSecondLevel(desc[0].value, preferredCampus);
                }
              }}
            />
            {(selectedEntryTerm === "1021" || selectedEntryTerm === 1021) &&
              (selectedSecondUniversity === 2 || selectedSecondUniversity === "2") &&
              (selectedSecondMajor === "121" || selectedSecondMajor === 121) ? (
              <p style={{ color: "red" }}>
                The Physiotherapy program is not available for Semester 2 (2025).
                Applications for this program and semester will be automatically deferred to the September 2026 intake.
              </p>
            ) : null}

            <InputRow
              name="select"
              rowName="Level"
              value={selectedSecondLevel}
              data={
                isFoundation == true && selectedSecondMajor !== ""
                  ? levelFoundationData
                  : levelSecondData
              }
              required={
                selectedSecondUniversity && selectedSecondMajor ? "*" : ""
              }
              errMsg={
                validationError.selectedSecondLevel
                  ? validationError.selectedSecondLevel
                  : ""
              }
              onChange={(e) => {
                this.setState({ selectedSecondLevel: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  secondDescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: e,
                  preferredCampus: preferredCampus,
                });
                //this.setState({ selectedSecondMajor: selectedSecondMajor, secondDescription: secondDescription })
              }}
            />
          </div>
          {selectedSecondLevel === "14" ? (
            <p style={{ color: "red" }}>
              Please note that your selection of entry into Year 3/Level 6 will
              be approved on a case-by-case basis, depending on the programme
              you are applying for. If your enrolment into Year 3/Level 6 is not
              approved by Coventry University, your application will be
              considered for enrolment into Year 2/Level 5, or Year 1/Level 4
            </p>
          ) : null}
          {selectedSecondLevel === "11" &&
            (secondDescription.includes("/ BENG /") ||
              secondDescription.includes("Engineering")) ? (
            <p style={{ color: "red" }}>
              The Year 1 entry selection process for the School of Engineering
              is solely applicable to transfer students from accredited
              institutions of higher education. If You are applying to the
              School of Engineering based on your high-school grades, you will
              be automatically considered for Foundation Year due to equivalency
              requirements.2
            </p>
          ) : null}
        </div>

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}
AcademicInterest.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  selectedProgram: PropTypes.number,
  selectedUniversity: PropTypes.number,
  selectedSecondProgram: PropTypes.number,
  selectedSecondUniversity: PropTypes.number,
  entryTerm: PropTypes.number,
  description: PropTypes.string,
  secondDescription: PropTypes.string,
  collectState: PropTypes.func,
  error: PropTypes.object,
  isFoundation: PropTypes.bool,
  changePopup: PropTypes.func,
  preferredCampus: PropTypes.string,
};
